import { features } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">为什么选择我们</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">平台优势</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">88影视网以三大核心优势打造极致高清视频网站体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {features.map((feat, idx) => (
            <div key={idx} className="group text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer">
              <div className="w-16 h-16 md:w-18 md:h-18 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}